'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _riskAnalysis = require('./risk-analysis.html');

var _riskAnalysis2 = _interopRequireDefault(_riskAnalysis);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _riskAnalysis2.default,
  bindings: {
    adverseEvent: '<',
    injurySeverities: '<',
    injuryProbabilities: '<',
    occurrenceLikelihoods: '<',
    locked: '<'
  },
  controller: function () {
    function RiskAnalysisComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, RiskAnalysisComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(RiskAnalysisComponent, [{
      key: 'getRiskScore',
      value: function getRiskScore() {
        var risks = [this.adverseEvent.AnalysisQ1 || 0, this.adverseEvent.AnalysisQ2 || 0, this.adverseEvent.AnalysisQ3 || 0];

        var sum = risks.reduce(function (a, b) {
          return a + b;
        }, 0);
        return sum;
      }
    }]);

    return RiskAnalysisComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/adverse-event/risk-analysis/risk-analysis.component.js